import styled from 'styled-components';
import { maxBodyWidth, topbarHeight, mobileBreakpoint } from '@styles/layout';

export const AppWrapper = styled.main`
  max-width: ${maxBodyWidth}px;
  margin: 0 auto;
  box-shadow: 0 0 12px rgba(0, 0, 0, 0.1);
  min-height: 100vh;
  position: relative;
  background: white;
  padding-top: ${topbarHeight}px;

  @media (max-width: ${mobileBreakpoint}px) {
		padding-top: 0;
	}
`;

export const ProSeparContainer = styled.div`
  margin-top: -300px;
`;


// WEBPACK FOOTER //
// src/app/src/components/App/App.s.ts